import { CookieManagerService } from './../../../shared/servicios/services.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { MiTiendaService } from 'src/app/@pages/dashboard/servicios/mi-tienda.service';
import Swal from 'sweetalert2';
import { Md5 } from 'ts-md5';
import { environment } from '~environment';
import { UsuarioModel } from '~shared/models/usuario';
import { AuthService } from '~shared/servicios/auth.service';
import { ServicesService } from '~shared/servicios/services.service';
import { InicioNComponent } from '../inicio-n.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends InicioNComponent implements OnInit {

  loginForm;
  recoverForm;
  error: string;

  //Atributes
  hidePass = true;

  //Formulario Olvido
  forg: boolean = false;

  // Reactivar
  mostraReact: boolean = false;
  mostraCont: boolean = false;
  idTiendaReact;
  timeLeft: number = 30;
  interval;
  inpCode: boolean = false;
  codigo;
  codigoValidacion;

  constructor(private auth: AuthService, private cookieService: CookieService, private cookieService2: CookieManagerService, public router: Router, public service: ServicesService, public cookieSvc: CookieService, public snackBar: MatSnackBar, private miTiendaService: MiTiendaService, public dialog: MatDialog) {
    super(router, service, cookieSvc, snackBar);
    this.loginForm = new FormGroup({
      usuario: new FormControl('', [Validators.required]),
      psw: new FormControl('', [Validators.required]),
      recordarme: new FormControl(false),
    });
    this.recoverForm = new FormGroup({
      usuario: new FormControl('', [Validators.required]),
    });

    if (this.auth.leerToken()) {
      this.router.navigateByUrl('/dashboard');
    }

    if (localStorage.getItem('user')) {
      this.loginForm.patchValue({
        usuario: localStorage.getItem('user'),
        recordarme: true,
      });
    }
  }

  ngOnInit(): void {
    if (environment.dbUsed === 'pruebas' && !this.cookieService.get(btoa('employeeLogin'))) {
      const dialogRef = this.dialog.open(ModalLoginTest, {
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    }
  }

  clickM() {
    const url = environment.dbUsed === 'pruebas' ? 'https://accounts.qa.triidy.com/register/' : 'https://accounts.triidy.com/register/';
    window.open(url, '_self')
  }

  get usuario() { return this.loginForm.get('usuario'); }

  get psw() { return this.loginForm.get('psw'); }

  get usuario2() { return this.recoverForm.get('usuario2'); }

  setObjectUserLogin(valueForm: UsuarioModel): UsuarioModel {
    return {
      usuario: valueForm.usuario,
      psw: valueForm.psw,
    };
  }

  olvideContrasenna(): void {
    this.forg = true;
  }

  send() {

    const valueForm: any = { ...this.loginForm.value, };
    const usuario = this.setObjectUserLogin(valueForm);

    const password = Md5.hashStr(usuario.psw);
    usuario.psw = password.toString();
    const recordar = (this.loginForm.value.recordarme);

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...',
    });
    Swal.showLoading();

    // console.log(usuario)

    this.auth.login(usuario, true).subscribe(resp => {
      // console.log('DATA', resp, resp[0].autoriza_v2, resp[0].key, resp[0].id_tienda);
      if (resp[0].autoriza_v2 === 'SI') {
        const modalShown = this.cookieService2.checkModalShown();
        this.auth.logout();
        Swal.close();
        if (!modalShown) {
          this.openModal(); // Si el modal no se ha mostrado, lo mostramos
        } else {
          const url = environment.dbUsed === 'pruebas' ? 'https://accounts.qa.triidy.com' : 'https://accounts.triidy.com';
          window.open(url, '_self')
        }
      } else {
        if (resp[0].key !== 'Error') {
          if (resp[0].key === 'Activar') {
            this.idTiendaReact = resp[0].id_tienda;
            Swal.fire({
              icon: 'error',
              title: 'Error al autenticar',
              text: /* resp[0].respuesta */ 'Tienda suspendida por inactividad',
            });
            this.mostraReact = true;
          } else {
            if (recordar) {
              localStorage.setItem('user', usuario.usuario);
            } else if (!recordar) {
              localStorage.removeItem('user');
            }

            setTimeout(() => {
              Swal.close();
              this.router.navigateByUrl('/dashboard');
            }, 1000);
          }
        }
      }
    }, (err) => {
      // console.log(err)
      this.error = err;
      const msg = this.error.toString();
      if (msg.includes('no existe') || msg.includes('incorrecta')) {
        Swal.fire({
          icon: 'error',
          title: 'Error al autenticar',
          text: 'Usuario o Contraseña incorrecta',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al autenticar',
          text: err,
        });
      }
    });

    /*console.log("usuario:", this.loginForm.value.user);
    console.log("contraseña:", this.loginForm.value.pass);
    console.log("este es el valor", typeof this.loginForm.value.pass);
    console.log("este es el valor", Md5.hashStr(this.loginForm.value.pass));*/
    this.loginForm.reset();
  }

  sendRecover(): void {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...',
    });
    Swal.showLoading();

    const valueForm: any = { ...this.recoverForm.value, };
    // console.log(valueForm.usuario);

    this.auth.recuperarPass(valueForm.usuario).subscribe((data) => {
      Swal.close();
      const respuesta = data[0].response;
      Swal.fire({
        allowOutsideClick: false,
        icon: 'info',
        text: respuesta,
        confirmButtonText: 'Aceptar',
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    })
  }

  preEnvioClave(): void {
    Swal.fire({
      allowOutsideClick: false,
      html: 'Se enviara un codigo al numero de administración registrado <br> ¿Seguir con el proceso?',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#FF780B',
      cancelButtonText: 'Cancelar',
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.miTiendaService.codigoSeguridadCuentaReactivacion(this.idTiendaReact, 'Activar').subscribe((data) => {
          // console.log(data);
          if (data[0].response === 'Success') {
            this.mostraCont = true;
            this.comenzarContador();
            this.inpCode = true;
          } else {
            Swal.fire({
              allowOutsideClick: false,
              icon: 'error',
              text: 'Hubo un error, recargue la pagina',
              confirmButtonText: 'Aceptar',
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        })
      } else if (result.isDismissed) {
        // console.log('Rechazado')
      }
    })
  }

  comenzarContador() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 30;
        this.mostraCont = false;
        clearInterval(this.interval);
      }
    }, 1000)
  }

  verificaClave(e): void {
    // console.log(e);
    if (e === '' || e === undefined || e === null) {
      Swal.fire({
        allowOutsideClick: false,
        title: 'Campo Vacio',
        // showCancelButton: true,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#FF780B',
        // cancelButtonText: 'Cancelar',
      });
    } else {
      this.miTiendaService.validarCodigoSeguridadCuentaReactivacion(e, this.idTiendaReact).subscribe((data) => {
        // console.log(data);
        if (data[0].response !== 'Autorizado') {
          Swal.fire({
            allowOutsideClick: false,
            title: 'Clave Erronea',
            // showCancelButton: true,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#FF780B',
            // cancelButtonText: 'Cancelar',
          }).then((result) => {
            if (result.isConfirmed) {
              this.codigo = '';
            }
            /* else if (result.isDismissed) {

            } */
          })
        } else {
          // console.log('valido')
          this.codigoValidacion = e;
          this.activarTienda();
        }
      });
    }
  }

  activarTienda(): void {
    this.auth.activarTienda(this.idTiendaReact).subscribe((data) => {
      // console.log(data);
      if (data[0].response === 'SUCCESS') {
        Swal.fire({
          allowOutsideClick: false,
          title: 'La tienda ha sido reactivada',
          // showCancelButton: true,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#FF780B',
          // cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            this.codigo = '';
            window.location.reload();
          }
          /* else if (result.isDismissed) {

          } */
        })
      } else {
        Swal.fire({
          allowOutsideClick: false,
          title: 'Ocurrio un error intente nuevamente',
          // showCancelButton: true,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#FF780B',
          // cancelButtonText: 'Cancelar',
        }).then((result) => {
          if (result.isConfirmed) {
            this.codigo = '';
            window.location.reload();
          }
          /* else if (result.isDismissed) {

          } */
        })
      }
    })
  }

  showPass() {
    this.hidePass = !this.hidePass;
  }
  openDialog() {
    const dialogRef = this.dialog.open(ModalLoginTest);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  openModal() {
    this.dialog.open(ModalComponent, {
      width: '80%',
      height: 'auto'  // Ajusta el tamaño según sea necesario
    });
  }
}

export interface UserModelTest {
  userTest: string;
  passTest: string;
}

export interface UserLoginTest {
  user: string;
  pwd: string | any;
}

@Component({
  selector: 'modal-login-test',
  templateUrl: 'login-test.component.html',
  styleUrls: ['./login.component.scss']
})
export class ModalLoginTest {

  loginForm
  //Atributes
  hidePass = true;
  errorLogg = false;
  showMessageError: boolean = false;
  messageError: string = '';

  constructor(private auth: AuthService,
    private formBuilder: FormBuilder,
    public router: Router,
    public cookieService: CookieService,
    public dialogRef: MatDialogRef<ModalLoginTest>) {
    this.loginForm = this.formBuilder.group({
      userTest: [
        '',
        [
          Validators.required,
          Validators.pattern('[A-Za-zÀ-ÿ0-9-. ]{1,60}'),
          Validators.max(60),
        ],
      ],
      passTest: ['', [Validators.required]],
    });
  }

  loginTest() {
    this.showMessageError = false;

    const valueForm: any = { ...this.loginForm.value };
    const objectToSend = this.setObjectLoginTest(valueForm);

    //Encrypt
    objectToSend.pwd = Md5.hashStr(objectToSend.pwd);

    const step = this.auth.loginTriidyTest(objectToSend).subscribe({
      next: (v) => {
        if (v[0]['isSuccess'] === true) {
          const data = v[0]['result'];

          const keyLoginEnt = btoa('employeeLogin');
          const encLoginEnt = btoa('1');

          const expire = new Date();
          const time = Date.now() + ((3600 * 1000) * 6); // current time + 6 hours ///
          expire.setTime(time);

          if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
            this.cookieService.set(keyLoginEnt, encLoginEnt, expire, '/', '');
          } else {
            this.cookieService.set(keyLoginEnt, encLoginEnt, expire, '/', environment.dbUsed !== 'Pruebas' ? '.triidy.com' : '.triidy.com');
          }

          this.router.navigate(['/iniciar-sesion'])

          setTimeout(() => {
            this.dialogRef.close();
            document.body.classList.remove('active-modal');
          }, 500);
        } else {
          // console.log(v[0]['errors']);
          this.messageError = v[0]['errors'];
          this.showMessageError = true;
        }
      },
      error: (e: HttpErrorResponse) => {
        console.warn(e)
      },
      complete: () => {
        step.unsubscribe();
      },
    });
  }

  setObjectLoginTest(valueForm: UserModelTest): UserLoginTest {
    return {
      user: valueForm.userTest,
      pwd: valueForm.passTest,
    };
  }

  showPass() {
    this.hidePass = !this.hidePass;
  }

}
@Component({
  templateUrl: 'modal-welcome.component.html',
  styleUrls: ['./modal-welcome.component.scss']
})
export class ModalComponent {

  constructor(private router: Router, public dialogRef: MatDialogRef<ModalComponent>, private cookieService: CookieManagerService) { }
  ngOnInit(): void {
    this.cookieService.setModalShown(); // Se marca la cookie cuando el modal se muestra
  }
  navigateToVersion2() {
    this.dialogRef.close();
    const url = environment.dbUsed === 'pruebas' ? 'https://accounts.qa.triidy.com' : 'https://accounts.triidy.com';
    window.open(url, '_self')
  }
}
